Namespace 'Monitoring.Reports.Publications.Subsections'

class Monitoring.Reports.Publications.Subsections.ChartView extends Backbone.View

  template: JST['backbone/templates/monitoring/reports/publications/content/subsections/subtitle']
  className: 'page-reach'
  initialize: (@options = {}, @title={}) ->
    # just set @options

  render: ->
    @$el.html(@template({title: @title}))
    page_reach_chart = new Monitoring.Views.Charts.LineChartView(@options, @title)
    @$('.chart').append(page_reach_chart.el)
    return this